import PropTypes from 'prop-types';
import React from 'react';

import { CONTACT_SECTION } from '@glass/web/modules/resumes/router/sections';

import BuilderButtonRow from '@glass/shared/components/ResumeBuilder/BuilderButtonRow';
import BuilderTitlePaperContainer from '@glass/shared/components/ResumeBuilder/BuilderTitlePaperContainer';
import ConnectedBuilderPreviewContainer from '@glass/shared/components/ResumeBuilder/ConnectedBuilderPreviewContainer';
import ContactFields from '@glass/shared/components/ResumeBuilder/fields/ContactFields';
import withFormValues from '@glass/shared/modules/form/withFormValues';

const EditableResume = withFormValues(({ changeFormField, ...otherProps }) => {
  return (
    <ConnectedBuilderPreviewContainer
      disableSaveToInbox
      activeSection={CONTACT_SECTION}
      {...otherProps}
    >
      <BuilderTitlePaperContainer
        subtitle="We suggest including an email"
        title="What's the best way for employers to contact you?"
        titleComponent="h4"
      >
        <ContactFields isMinimal />
        <BuilderButtonRow disableBack fixedButtonBar={false} preventBlock={false} />
      </BuilderTitlePaperContainer>
    </ConnectedBuilderPreviewContainer>
  );
});

EditableResume.propTypes = {
  iSlug: PropTypes.string,
  jSlug: PropTypes.string,
  loading: PropTypes.bool,
  seedOverride: PropTypes.string,
  skip: PropTypes.bool,
  statusTitle: PropTypes.string,
};

export default EditableResume;
